import React from 'react';
import {CtaButton} from '@optimaxdev/design-system';

import s from './appCrashFallback.scss';

/**
 * Fallback which renders if app crashed
 *
 * @returns {React.ReactNode} - react component
 */
export const AppCrashFallback: React.FC<{}> = () => {
    const reloadPage = () => {
        window.location.reload();
    };
    return (
        <div className={s.wrapper}>
            <h1 className={s.header}>Looks like something went wrong.</h1>
            <CtaButton isFull={false} size="regular" onClick={reloadPage}>
                Reload page
            </CtaButton>
        </div>
    );
};

AppCrashFallback.displayName = 'AppCrashFallback';
